import {
  location,
  history,
  match,
  route,
} from './reactRouterPropsTypes.ts';

export {
  location,
  history,
  match,
  route,
};



// WEBPACK FOOTER //
// ./src/utils/index.js